import { Environment } from 'src/common/constants/Environment';

export function isDevelopment(nodeEnv: string = process.env.NODE_ENV): boolean {
  return !nodeEnv || nodeEnv === Environment.DEVELOPMENT;
}
